"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestStepConfigDtoFooterEnum = exports.DigestStepConfigDtoSelectionModeEnum = exports.DigestStepConfigDtoInputTypeEnum = exports.DigestStepConfigDtoDimensionEnum = void 0;
exports.instanceOfDigestStepConfigDto = instanceOfDigestStepConfigDto;
exports.DigestStepConfigDtoFromJSON = DigestStepConfigDtoFromJSON;
exports.DigestStepConfigDtoFromJSONTyped = DigestStepConfigDtoFromJSONTyped;
exports.DigestStepConfigDtoToJSON = DigestStepConfigDtoToJSON;
exports.DigestStepConfigDtoToJSONTyped = DigestStepConfigDtoToJSONTyped;
var DigestOptionDto_1 = require("./DigestOptionDto");
var DigestCopyDto_1 = require("./DigestCopyDto");
var DigestStepVisibilityDto_1 = require("./DigestStepVisibilityDto");
/**
 * @export
 */
exports.DigestStepConfigDtoDimensionEnum = {
    Teams: 'teams'
};
/**
 * @export
 */
exports.DigestStepConfigDtoInputTypeEnum = {
    TeamCardGrid: 'teamCardGrid'
};
/**
 * @export
 */
exports.DigestStepConfigDtoSelectionModeEnum = {
    Single: 'single',
    Multi: 'multi'
};
/**
 * @export
 */
exports.DigestStepConfigDtoFooterEnum = {
    SkipAndContinue: 'skipAndContinue',
    ContinueOnly: 'continueOnly',
    DualAction: 'dualAction'
};
/**
 * Check if a given object implements the DigestStepConfigDto interface.
 */
function instanceOfDigestStepConfigDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('dimension' in value) || value['dimension'] === undefined)
        return false;
    if (!('question' in value) || value['question'] === undefined)
        return false;
    if (!('inputType' in value) || value['inputType'] === undefined)
        return false;
    if (!('selectionMode' in value) || value['selectionMode'] === undefined)
        return false;
    if (!('required' in value) || value['required'] === undefined)
        return false;
    if (!('skippable' in value) || value['skippable'] === undefined)
        return false;
    if (!('options' in value) || value['options'] === undefined)
        return false;
    return true;
}
function DigestStepConfigDtoFromJSON(json) {
    return DigestStepConfigDtoFromJSONTyped(json, false);
}
function DigestStepConfigDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'dimension': json['dimension'],
        'question': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['question']),
        'instruction': json['instruction'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['instruction']),
        'inputType': json['inputType'],
        'selectionMode': json['selectionMode'],
        'required': json['required'],
        'skippable': json['skippable'],
        'showSelectAll': json['showSelectAll'] == null ? undefined : json['showSelectAll'],
        'footer': json['footer'] == null ? undefined : json['footer'],
        'visibility': json['visibility'] == null ? undefined : (0, DigestStepVisibilityDto_1.DigestStepVisibilityDtoFromJSON)(json['visibility']),
        'searchPlaceholder': json['searchPlaceholder'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['searchPlaceholder']),
        'playersSearchEndpoint': json['playersSearchEndpoint'] == null ? undefined : json['playersSearchEndpoint'],
        'options': (json['options'].map(DigestOptionDto_1.DigestOptionDtoFromJSON)),
    };
}
function DigestStepConfigDtoToJSON(json) {
    return DigestStepConfigDtoToJSONTyped(json, false);
}
function DigestStepConfigDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'dimension': value['dimension'],
        'question': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['question']),
        'instruction': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['instruction']),
        'inputType': value['inputType'],
        'selectionMode': value['selectionMode'],
        'required': value['required'],
        'skippable': value['skippable'],
        'showSelectAll': value['showSelectAll'],
        'footer': value['footer'],
        'visibility': (0, DigestStepVisibilityDto_1.DigestStepVisibilityDtoToJSON)(value['visibility']),
        'searchPlaceholder': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['searchPlaceholder']),
        'playersSearchEndpoint': value['playersSearchEndpoint'],
        'options': (value['options'].map(DigestOptionDto_1.DigestOptionDtoToJSON)),
    };
}
